import { c as _c } from "react/compiler-runtime";
import { Box } from "@chakra-ui/react";
interface IntervalSegmentsProps {
  intervalOverlays: OverlaySegment[];
  selectedOverlays: OverlaySegment[];
}
export interface OverlaySegment {
  startPercent: number;
  widthPercent: number;
}
export const IntervalSegments = t0 => {
  const $ = _c(7);
  const {
    intervalOverlays,
    selectedOverlays
  } = t0;
  let t1;
  if ($[0] !== intervalOverlays) {
    t1 = intervalOverlays.map(_temp);
    $[0] = intervalOverlays;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== selectedOverlays) {
    t2 = selectedOverlays.map(_temp2);
    $[2] = selectedOverlays;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(interval, idx) {
  return <Box key={`interval-${idx}`} position="absolute" top="0" height="100%" bg="grey.300" borderRadius="button" pointerEvents="none" left={`${interval.startPercent}%`} width={`${interval.widthPercent}%`} />;
}
function _temp2(interval_0, idx_0) {
  return <Box key={`selected-interval-${idx_0}`} position="absolute" top="0" height="100%" bg="secondary" borderRadius="button" pointerEvents="none" left={`${interval_0.startPercent}%`} width={`${interval_0.widthPercent}%`} zIndex={1} />;
}